import { ButtonType } from "@xemplo/button";
import { DawnTriangleAlert } from "@xemplo/icons";
import { Prompt, PromptDialogSlot } from "@xemplo/prompt-dialog";
import { Colour } from "@xemplo/style-constants";

type SkipPayrunPromptProps = {
  dialogProps: any;
  promptProps: any;
  onConfirm: () => void;
  onClose: () => void;
};

export const SkipPayrunPrompt = ({
  dialogProps,
  promptProps,
  onConfirm,
  onClose,
}: SkipPayrunPromptProps) => {
  return (
    <Prompt.Dialog {...dialogProps}>
      <Prompt {...promptProps}>
        <Prompt.Slot
          name={PromptDialogSlot.CloseButton}
          render={
            <Prompt.CloseButton
              id="close-skip-prompt-close-button"
              ariaLabel="Close skip payrun prompt"
              onClick={onClose}
            />
          }
        />
        <Prompt.Slot
          name={PromptDialogSlot.Header}
          render={
            <Prompt.Header
              icon={<DawnTriangleAlert color={Colour.Red[500]} />}
              title="Confirm Skip"
            />
          }
        />
        <Prompt.Slot
          name={PromptDialogSlot.Body}
          render={
            <Prompt.Body>
              <>
                <p>Are you sure you want to skip this pay run?</p>
                <p>You cannot undo this action</p>
              </>
            </Prompt.Body>
          }
        />
        <Prompt.Slot
          name={PromptDialogSlot.Footer}
          render={
            <Prompt.Footer
              btnPrimary={{
                label: "Delete",
                onClick: onConfirm,
                type: ButtonType.Destructive,
                ariaLabel: "Skip payrun",
              }}
              btnSecondary={{
                label: "Cancel",
                onClick: onClose,
                type: ButtonType.Secondary,
                ariaLabel: "Cancel skip",
              }}
            />
          }
        />
      </Prompt>
    </Prompt.Dialog>
  );
};
